(() => {
  const root = document.documentElement;
  let initialized = false;

  const init = () => {
    if (initialized) return true;

    const revealItems = [...document.querySelectorAll('[data-hydros-reveal]')];
    const countItems = [...document.querySelectorAll('[data-hydros-count]')];
    const videos = [...document.querySelectorAll('[data-hydros-video]')];
    const ugcDialogs = [...document.querySelectorAll('[data-hydros-ugc-dialog]')];

    if (!revealItems.length && !countItems.length && !videos.length && !ugcDialogs.length) return false;
    initialized = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveal = (element) => element.classList.add('is-revealed');

    const loadVideo = (video) => {
      if (video.dataset.hydrosLoaded) return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.hydrosLoaded = 'true';
      video.load();
    };

    const animateCount = (element) => {
      if (element.dataset.hydrosAnimated) return;
      element.dataset.hydrosAnimated = 'true';
      const target = Number.parseFloat(element.dataset.hydrosCount || '0');
      const from = Number.parseFloat(element.dataset.hydrosFrom || '0');
      const decimals = Number.parseInt(element.dataset.hydrosDecimals || '0', 10);
      const format = (value) => value.toLocaleString('fr-FR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

      if (reducedMotion || !Number.isFinite(target) || !Number.isFinite(from) || (target === 0 && from === 0)) {
        element.textContent = format(Number.isFinite(target) ? target : 0);
        return;
      }

      const start = performance.now();
      const duration = 720;
      const tick = (time) => {
        const progress = Math.min(1, (time - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = format(from + (target - from) * eased);
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const initUgcDialogs = () => {
      ugcDialogs.forEach((dialog) => {
        const section = dialog.closest('.hydros-ugc-bubbles');
        const player = dialog.querySelector('[data-hydros-ugc-player]');
        const title = dialog.querySelector('[data-hydros-ugc-title]');
        const closeButton = dialog.querySelector('[data-hydros-ugc-close]');
        const openButtons = [...section.querySelectorAll('[data-hydros-ugc-open]')];
        const previews = [...section.querySelectorAll('[data-hydros-video]')];

        const cleanPlayer = () => {
          player.pause();
          player.removeAttribute('src');
          player.removeAttribute('poster');
          player.classList.remove('is-landscape', 'is-routine');
          player.load();
          previews.forEach((preview) => preview.play().catch(() => {}));
        };

        const closeDialog = () => {
          if (typeof dialog.close === 'function' && dialog.open) dialog.close();
          else dialog.removeAttribute('open');
        };

        openButtons.forEach((button) => {
          button.addEventListener('click', () => {
            previews.forEach((preview) => preview.pause());
            player.src = button.dataset.videoSrc;
            player.poster = button.dataset.videoPoster || '';
            player.classList.toggle('is-landscape', button.dataset.videoFormat === 'landscape');
            player.classList.toggle('is-routine', button.dataset.videoCrop === 'routine');
            title.textContent = button.dataset.videoTitle || '';

            if (typeof dialog.showModal === 'function') dialog.showModal();
            else dialog.setAttribute('open', '');

            player.load();
            player.play().catch(() => {});
          });
        });

        closeButton.addEventListener('click', closeDialog);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });
        dialog.addEventListener('close', cleanPlayer);
        dialog.addEventListener('cancel', cleanPlayer);
      });
    };

    initUgcDialogs();

    if (reducedMotion || typeof window.IntersectionObserver !== 'function') {
      revealItems.forEach(reveal);
      countItems.forEach(animateCount);
      videos.forEach((video) => {
        loadVideo(video);
        video.controls = true;
        video.removeAttribute('autoplay');
      });
      root.classList.add('hydros-motion-ready');
      return true;
    }

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });

    const countObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.55 });

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadVideo(video);
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.35, rootMargin: '180px 0px' });

    revealItems.forEach((item) => revealObserver.observe(item));
    countItems.forEach((item) => countObserver.observe(item));
    videos.forEach((video) => videoObserver.observe(video));

    root.classList.add('hydros-motion-ready', 'hydros-motion-active');

    requestAnimationFrame(() => {
      revealItems.forEach((item) => {
        const bounds = item.getBoundingClientRect();
        if (bounds.top < window.innerHeight * 0.94 && bounds.bottom > 0) reveal(item);
      });
    });

    window.setTimeout(() => revealItems.forEach(reveal), 3500);
    return true;
  };

  const start = () => {
    if (!init()) window.setTimeout(init, 60);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    window.setTimeout(start, 0);
  }
})();
